import React from 'react';

// Rich, non-primary palette for deterministic initials avatars. Each account
// keeps the same colour based on a hash of its username/name/email.
export const PALETTE = [
  'bg-rose-500', 'bg-pink-500', 'bg-fuchsia-500', 'bg-violet-500',
  'bg-indigo-500', 'bg-blue-500', 'bg-sky-500', 'bg-cyan-600',
  'bg-teal-600', 'bg-emerald-600', 'bg-green-600', 'bg-lime-600',
  'bg-amber-500', 'bg-orange-500', 'bg-red-500',
];

function hashString(s) {
  let h = 0;
  for (let i = 0; i < s.length; i += 1) {
    h = (h * 31 + s.charCodeAt(i)) | 0; // eslint-disable-line no-bitwise
  }
  return Math.abs(h);
}

function deriveInitials(seed) {
  const s = (seed || '').trim();
  if (!s) return '?';
  const parts = s.split(/[\s._-]+/).filter(Boolean);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  return s.slice(0, 2).toUpperCase();
}

/**
 * Colored initials avatar for accounts without a profile picture.
 * - `seed` drives the initials and the default colour (stable per user).
 * - `color` (optional Tailwind bg class) overrides the automatic colour when
 *   the user has chosen one.
 * - `size` is the pixel diameter.
 */
export const InitialsAvatar = ({ seed = '', color = '', size = 20, className = '' }) => {
  const key = (seed || '?').toString();
  const resolved = color && PALETTE.includes(color)
    ? color
    : PALETTE[hashString(key.toLowerCase()) % PALETTE.length];
  const initials = deriveInitials(key);
  return (
    <span
      data-testid="initials-avatar"
      aria-hidden="true"
      className={`inline-flex shrink-0 items-center justify-center rounded-full font-semibold leading-none text-white ${resolved} ${className}`}
      style={{ width: size, height: size, fontSize: Math.max(9, Math.round(size * 0.42)) }}
    >
      {initials}
    </span>
  );
};
